import React, { useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Drawer,
  Box,
  TextField,
  Grid,
  CircularProgress
} from "@mui/material";
import PaginationComp from "../../Pagination/PaginationComp";
import Popover from "@mui/material/Popover";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";

const PayoutTable = ({
  merchant,
  message,
  page,
  totalPage,
  setPage,
  ReadData,
  authRead,
  authDelete,
  authUpdate,
  loading
}) => {

  const currencyFlags = {
    ARS: "arsflag.svg",
    AZN: "aznflag.svg",
    COP: "copflag.svg",
    EGP: "egpflag.svg",
    GHC: "ghcflag.svg",
    IDR: "idrflag.svg",
    INR: "inrflag.svg",
    JPY: "jpyflag.svg",
    KZT: "kztflag.svg",
    KGS: "kgsflag.svg",
    PHP: "phpflag.svg",
    BDT: "bdtflag.svg",
    BRL: "brlflag.svg",
    CLP: "clpflag.svg",
    CNY: "cnyflag.svg",
    CRC: "crcflag.svg",
    EUR: "euroflag.svg",
    GTQ: "gtqflag.svg",
    KRW: "krwflag.svg",
    KES: "kesflag.svg",
    LAK: "lakflag.svg",
    MXN: "mxnflag.svg",
    MYR: "myrflag.svg",
    NGN: "ngnflag.svg",
    PEN: "penflag.svg",
    PKR: "pkrflag.svg",
    THB: "thbflag.svg",
    UGX: "ugxflag.svg",
    USD: "usdflag.svg",
    USDT: "usdflag.svg",
    VND: "vndflag.svg",
    ZAR: "zarflag.svg",
    PLN: "plnflag.svg",
    RUB: "rubflag.svg",
    SGD: "sgdflag.svg",
    TRY: "tryflag.svg",
    UAH: "uahflag.svg",
    GBP: "gbpflag.svg",
    UZS: "uzsflag.svg",
    BIF: "bifflag.svg",
    XAF: "xafflag.svg",
    TZSHS: "tzshsflag.svg",
    ZMW: "zmwflag.svg",
    AED: "uaeflag.svg",
    MDL: "mdlflag.svg",
    XOF: "xofflag.svg",
    RWF: "rwfflag.svg",
  };

  const getCurrencyFlag = (currencyCode) => {
    try {
      return require(`../../assets/currencyFlags/${currencyFlags[currencyCode]}`);
    } catch (err) {
      console.error(`Error loading flag for ${currencyCode}:`, err);
      return null; 
    }
  };

  return (
    <>
      <div style={{ maxHeight: "calc(100vh - 180px)", overflowY: "auto", marginTop: "16px", position: "relative" }}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" my={3}>
            <CircularProgress sx={{color: "#ff6600"}} />
          </Box>
        ) : (
          <Table
            stickyHeader
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
              "& th, & td": {
                padding: "10px 12px",
                fontSize: "13.5px",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#f1f5f9",
                position: "sticky",
                top: 0,
                zIndex: 1,
                "& th": {
                  fontWeight: 600,
                  color: "#1f2937",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "#f1f5f9",
                  whiteSpace: 'nowrap'
                },
              }}
            >
              <TableRow>
                {[
                  "Payout",
                  "UTR No./Ref. ID",
                  "Account Number",
                  "Currency",
                  "Requested Amount",
                  "Paid Amount",
                  "Charges",
                  "Bank Charges",
                  "Net Payout",
                  "Status",
                  "Initiated On",
                  "Action",
                ].map((heading) => (
                  <TableCell key={heading}>
                    <Typography
                      variant="h6"
                    >
                      {heading}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {merchant.map((merchant, index) => (
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    "&:hover": {
                      backgroundColor: "#f1f1f1",
                    },
                  }}
                >
                  <TableCell>
                    <Typography
                      variant="h6"
                      sx={{
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <span style={{ color: "#1eaae7"}}>ORDER ID: {merchant.uniqueid}</span><br />
                      <span style={{ color: "#ff9800"}}>PAYEE NAME: {merchant.payee_name}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.utrnumber}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      <span style={{ color: "#1eaae7"}}>{merchant.creditacc}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center"
                      }}
                      variant="h6"
                    >
                        <img src={getCurrencyFlag(merchant.currency)} alt={merchant.currency} width="30px" /> &nbsp;&nbsp;
                      {merchant.currency}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.amount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.txn_amount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.akonto_charge}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.bank_charges ? merchant.bank_charges : 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.wallet_deduct}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                          textAlign: "center",
                          color: 
                            merchant.status === 'FAILED'
                          ? "red"
                          : merchant.status === 'SUCCESS'
                          ? "green"
                          : "orange",
                          textTransform: "uppercase"
                      }}
                      variant="h6"
                    >
                      {
                        merchant.status === 'FAILED'
                        ? "FAILED"
                        : merchant.status === 'SUCCESS'
                        ? "SUCCESS"
                        : "PENDING"
                      }
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.created_on}
                    </Typography>
                  </TableCell>             
                  <TableCell align="center">
                    {authRead ? (
                      <ViewDrawer item={merchant} authRead={authRead} />
                    ) : null}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={12} align="center">
                  
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <PaginationComp
        setPage={setPage}
        page={page}
        totalPage={totalPage}
        message={message}
        disabled={loading}
      />
    </>
  );
};

const ViewDrawer = ({ item, authRead }) => {
  const [state, setState] = useState({ right: false });

  const toggleDrawer = (open) => () => {
    setState({ right: open });
    if (open) {
        // console.log(item)
    } else {
      // window.location.reload();
    }
  };

  const statusMap = {
    'FAILED': "FAILED",
    "SUCCESS": "SUCCESS",
    "PENIDNG": "PENDING"
  };


  return (
    <div>
      {authRead && (
        <button
          className="btn btn-secondary btn-sm"
          onClick={toggleDrawer(true)}
        >
          View
        </button>
      )}
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)} PaperProps={{ style: { zIndex: 3 }, }}>
        <Box role="presentation" sx={{ width: {xs: 300, sm: 500} }}>
          <div style={{ padding: "20px", position: "relative" }}>
            <h4>PAYOUT DETAILS</h4>
            <button
              style={{
                position: "absolute",
                top: "22px",
                right: "10px",
                background: "#ff6600",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                width: "25px",
                height: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={toggleDrawer(false)}
            >
              <svg
                xmlns="http://www .org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <Grid container spacing={2}>
              {[
                { label: "PAYOUT ID.", value: item?.uniqueid || "NOT AVAILABLE" },
                { label: "URT NO.", value: item?.utrnumber || "NOT AVAILABLE" },
                { label: "PAYEE NAME", value: item?.payee_name || "NOT AVAILABLE" },
                { label: "PAYOUT STATUS", value: statusMap[item?.status] || "NOT AVAILABLE" },
                { label: "EMAIL", value: item?.email || "NOT AVAILABLE" },
                { label: "CURRENCY", value: item?.currency || "NOT AVAILABLE" },
                { label: "ACCOUNT NUMBER", value: item?.creditacc || "NOT AVAILABLE" },
                { label: "ADDRESS", value: item?.address || "NOT AVAILABLE" },
                { label: "CITY", value: item?.city || "NOT AVAILABLE" },
                { label: "STATE", value: item?.state || "NOT AVAILABLE" },
                { label: "COUNTRY", value: item?.country || "NOT AVAILABLE" },
                { label: "PIN CODE", value: item?.pin || "NOT AVAILABLE" },
                { label: "REQUESTED AMOUNT", value: item?.txn_amount || "NOT AVAILABLE" },
                { label: "PAID AMOUNT", value: item?.amount || "NOT AVAILABLE" },
                { label: "CHARGES", value: item?.akonto_charge != null || item?.bank_charges != null || item?.gst_amount ? Number(item.akonto_charge) + Number(item.bank_charges) + Number(item.gst_amount) : "NOT AVAILABLE" },
                { label: "NET PAYOUT", value: item?.amount != null || item?.akonto_charge != null || item?.bank_charges != null || item?.gst_amount ? parseFloat(Number(item?.amount) + (Number(item.akonto_charge) + Number(item.bank_charges) + Number(item.gst_amount))).toFixed(2) : "NOT AVAILABLE" },
              ].map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={field.label}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={field.value}
                    InputProps={{ readOnly: true, style: { zIndex: 4} }}
                    disabled
                  />
                </Grid>
              ))}
              <Grid item xs={12} sm={12}>
                <TextField
                  label="REASON"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={item.response}
                  multiline
                  minRows={2}
                  maxRows={10} 
                  InputProps={{ readOnly: true }}
                  disabled
                />
              </Grid>
            </Grid>
          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default PayoutTable;